const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-react] logger called before configureReactLogger()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-react] logger called before configureReactLogger()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-react] logger called before configureReactLogger()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-react] logger called before configureReactLogger()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-react] logger called before configureReactLogger()');
        console.error(...args);
    },
    isError: () => true,
};
export let logger = TempLogger;
export function setLogger(nextLogger) {
    logger = nextLogger;
}
//# sourceMappingURL=logger.js.map